// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"553":"2870f543","624":"d2ad347e"}[chunkId] + ".chunk.css";
};